import React from 'react';
import { Alert, AlertTitle, Grid } from '@mui/material';
import LoadingButton from '@mui/lab/LoadingButton';
import { Refresh } from '@mui/icons-material';

import { ButtonStyles } from './Button.styles';

interface CheckoutFailureProps {
  onRetry: () => void;
  isLoading: boolean;
}

const CheckoutFailure: React.FC<CheckoutFailureProps> = ({ onRetry, isLoading }) => (
  <Grid
    container
    direction="column"
    justifyContent="center"
    alignItems="center"
    sx={{ height: '100%', pb: 8 }}
  >
    <Alert severity="error" sx={{ mb: 4, mx: 2 }}>
      <AlertTitle>Error Gathering Info</AlertTitle>
      We’re sorry, there was an error gathering your payment information
      <br />
      <br />
      Please try again
    </Alert>
    <LoadingButton onClick={onRetry} loading={isLoading} endIcon={<Refresh />} {...ButtonStyles}>
      Try again
    </LoadingButton>
  </Grid>
);

export default CheckoutFailure;
